<template>
    <div class="page">
<!--        <div class="fixed-top">-->
<!--            <div class="toolbar van-hairline&#45;&#45;bottom">-->
<!--                <div class="tool-item btn-select-sort van-hairline&#45;&#45;right" @click="orderTypeActionSheet.show = true">-->
<!--                    类型：{{ $store.state.OrderTypeEnum.getLabel(orderType) || '全部' }}<span class="caret"></span></div>-->
<!--            </div>-->
<!--        </div>-->

        <van-list
                v-model="loading"
                :finished="listFinished"
                finished-text="没有更多了"
                @load="loadData"
        >
            <van-cell-group class="order-list">
                <van-cell v-for="(item, index) in list" :key="index" size="large" center clickable is-link
                          :to="'/clerk/order/detail/'+ item.id">
                    <div class="order-item">
                        <div class="left align-center">
                            <div class="padding-left-sm">
                                <div>

                                    <!--<van-tag v-if="item.type == 'assigned'" plain style="margin-left: 6px;">续单</van-tag>-->
                                    <span v-if="item.type != 'reward'">
                    {{item.itemCategory != null ? item.itemCategory.name + '-' : ''}}
                    {{ item.item.names.join('-') }} × {{ item.num }}</span>
                                </div>
                                <div>
                                    <span>{{ formatDate(item.createTime, 'MM-DD HH:mm') }}</span>
                                </div>
                                <div v-if="item.userMemo != null && item.userMemo != ''" class="userMemo">备注：{{ item.userMemo }}</div>
                            </div>
                        </div>
                        <div class="right">
                            <van-tag v-if="item.status == 0" type="danger" size="medium">待接单</van-tag>
                            <van-tag v-else-if="item.status == 1" color="#ff976a" size="medium">待开始</van-tag>
                            <van-tag v-else-if="item.status == 2" type="primary" size="medium">服务中</van-tag>
                            <van-tag v-else-if="item.status == 3" type="success" size="medium">已完成</van-tag>
                            <van-tag v-else-if="item.status == -1" size="medium">已取消</van-tag>
                            <div class="text-center">
                                <span class="total-amount">¥{{ formatPrice(item.totalAmount)}}</span>
                            </div>
                        </div>
                    </div>
                </van-cell>
            </van-cell-group>
        </van-list>

        <!--上拉选择订单类型-->
        <van-action-sheet
                v-model="orderTypeActionSheet.show"
                :actions="orderTypeActionSheet.actions"
                cancel-text="取消"
                @select="onOrderTypeActionSheetChange"
        />

    </div>
</template>

<script>
    import Vue from 'vue';
    import {Tab, Tabs, Search, Button, List, Cell, CellGroup, Tag, Icon, ActionSheet, Dialog, Panel, Image} from 'vant';
    import {getRandomList} from '@/api/clerk/random'
    import moment from 'moment';
    import Decimal from 'decimal.js';

    Vue.use(Tab)
        .use(Tabs)
        .use(Search)
        .use(Button)
        .use(List)
        .use(Cell)
        .use(CellGroup)
        .use(Tag)
        .use(Icon)
        .use(ActionSheet)
        .use(Dialog)
        .use(Panel)
        .use(Image)

    export default {
        name: 'clerk-order-list',
        components: {},
        data() {
            return {
                orderType: null,
                orderTypeActionSheet: {
                    show: false,
                    actions: []
                },
                list: [],
                loading: false,
                listFinished: false,
                pageNo: 1,
                pageSize: 10
            }
        },
        methods: {
            formatDate(date, format) {
                if (!date) {
                    return '';
                }
                if (!format) {
                    format = 'YYYY-MM-DD'
                }
                return moment(date).format(format);
            },
            formatPrice(price) {
                if (price != null) {
                    return Decimal.div(price, 100).toString()
                }
                return ''
            },
            onOrderTypeActionSheetChange(item) {
                this.orderType = item.value
                this.orderTypeActionSheet.show = false
                this.loadData(true)
            },
            loadData(resetFirstPage) {
                // 重置为首页
                if (resetFirstPage) {
                    this.pageNo = 1
                }
                // 清空数据
                if (this.pageNo == 1) {
                    this.list = [];
                }
                this.loading = true
                getRandomList(this.pageNo, this.pageSize).then(res => {
                    this.loading = false
                    const data = res.data;
                    if (data.code == 0) {
                        this.list = this.list.concat(data.list)
                        if (data.hasNextPage) {
                            this.listFinished = false
                        } else {
                            this.listFinished = true
                        }
                    } else {
                        this.listFinished = true
                        Dialog.alert({
                            title: '加载失败',
                            message: data.msg
                        })
                    }
                    this.pageNo++
                })
            }
        },
        mounted() {

            let orderTypeActions = [{
                name: '全部',
                value: null
            }]
            for (const item of this.$store.state.OrderTypeEnum.list()) {
                orderTypeActions.push({
                    name: item.label,
                    value: item.value
                })
            }
            this.orderTypeActionSheet.actions = orderTypeActions;
        }
    }
</script>

<style lang="less" scoped>

    .page {

        padding-bottom: 100px;
    }

    .fixed-top {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 1000;

        .toolbar {
            height: 44px;
            font-size: 14px;
            background: #fff;
            position: relative;
            display: flex;

            .tool-item {
                position: relative;
                padding: 12px 0;
                text-align: center;
                flex: 1;
            }
        }
    }

    .order-item {
        display: flex;
        align-items: center;

        .userMemo {
            color: #999;
        }

        .left {
            flex: 1;
            display: flex;

            .service-info {
                color: #333;
            }

            .created {
                color: #555;
                margin-bottom: 5px;
            }

            .user_head {
                position: relative;

                .level {
                    position: absolute;
                    left: 50%;
                    height: 12px;
                    font-size: 10px;
                    white-space: nowrap;
                    bottom: 0px;
                    transform: translateX(-50%);
                }
            }
        }

        .right {
            text-align: right;
            min-width: 30px;

            .total-amount {
                color: #333;
            }
        }
    }

</style>
